import {
  BrainCircuit, Database, BarChart3, TrendingUp, Cloud, Workflow,
  Landmark, HeartPulse, ShoppingCart, Factory, Truck, Cpu, Briefcase, Layers,
  Target, Zap, LineChart, Rocket, Focus, PenTool, Boxes, Sparkles, Handshake,
} from "lucide-react";

const MAP = {
  BrainCircuit, Database, BarChart3, TrendingUp, Cloud, Workflow,
  Landmark, HeartPulse, ShoppingCart, Factory, Truck, Cpu, Briefcase, Layers,
  Target, Zap, LineChart, Rocket, Focus, PenTool, Boxes, Sparkles, Handshake,
};

export default function Icon({ name, className = "h-6 w-6" }) {
  const Cmp = MAP[name] || Sparkles;
  return <Cmp className={className} aria-hidden="true" />;
}
